import * as React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import ExpandedSectionCount from "components/common/EntityDataTable/ExpandedSectionCount";
import { useInputMetricsFor } from "components/inputs/InputsOveriew/InputMetricsContext";
import { METRIC_COLUMN_IDS } from "components/inputs/InputsOveriew/metricColumns";
const SECTION_NAME = METRIC_COLUMN_IDS.messagesPerStream;
const sumValues = (counts) => Object.values(counts).reduce((sum, value) => sum + value, 0);
const MessageCountCell = ({ input }) => {
  const { t } = useTranslation("inputs");
  const { metrics, isInitialLoading, isError } = useInputMetricsFor(input.id);
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (isError || !(metrics == null ? void 0 : metrics.messages_per_stream)) {
    return /* @__PURE__ */ React.createElement("span", { "aria-label": t("overview.cells.no_message_count", { title: input.title }) }, "\u2014");
  }
  const total = sumValues(metrics.messages_per_stream);
  return /* @__PURE__ */ React.createElement(
    ExpandedSectionCount,
    {
      entityId: input.id,
      section: SECTION_NAME,
      count: total,
      label: t("overview.cells.messages_per_stream_label", { title: input.title }),
      abbreviate: true
    }
  );
};
export default MessageCountCell;
